import { createContext, useContext, useState } from "react";
import { createPortal } from "react-dom";

const ConfirmationContext = createContext(() => Promise.resolve(false));

export function AppModalProvider({ children }) {
  const [dialog, setDialog] = useState(null);
  const confirm = (message, title = "Aktion bestätigen") => new Promise(resolve => setDialog({ message, title, resolve }));
  const close = accepted => { if (dialog) dialog.resolve(accepted); setDialog(null); };
  return <ConfirmationContext.Provider value={confirm}>
    {children}
    {dialog && createPortal(<div className="app-modal-backdrop" role="presentation"><section className="app-modal" role="dialog" aria-modal="true" aria-labelledby="app-modal-title"><h2 id="app-modal-title">{dialog.title}</h2><p>{dialog.message}</p><div className="app-modal__actions"><button type="button" className="btn btn-secondary" onClick={() => close(false)}>Abbrechen</button><button type="button" className="btn btn-danger" onClick={() => close(true)}>Ja, fortfahren</button></div></section></div>, document.body)}
  </ConfirmationContext.Provider>;
}

export const useConfirmation = () => useContext(ConfirmationContext);
